var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24H4.5C2.01453 24 0 21.9855 0 19.5V4.5C0 2.01453 2.01453 0 4.5 0H19.5C21.9855 0 24 2.01453 24 4.5V19.5C24 21.9855 21.9855 24 19.5 24Z",
    fill: "#FFE6E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7074 12L15.7126 8.99467C15.9076 8.79967 15.9076 8.48326 15.7126 8.28752C15.5176 8.09178 15.2012 8.09251 15.0054 8.28752L12.0001 11.2926L8.9948 8.28752C8.79979 8.09251 8.48338 8.09251 8.28764 8.28752C8.0919 8.48253 8.09264 8.79894 8.28764 8.99467L11.2928 12L8.28764 15.0053C8.09264 15.2003 8.09264 15.5167 8.28764 15.7124C8.38506 15.81 8.51341 15.8587 8.64085 15.8587C8.76903 15.8587 8.89665 15.81 8.99406 15.7124L12.0001 12.7073L15.0054 15.7124C15.1028 15.81 15.2312 15.8587 15.3586 15.8587C15.4861 15.8587 15.6144 15.81 15.7118 15.7124C15.9068 15.5174 15.9068 15.201 15.7118 15.0053L12.7074 12Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.eedf6e92032e6b64f4b16368ff15fc50.svg";
export { ForwardRef as ReactComponent };